// custom.js


  $(document).ready(function() {
    $('.accordion-item .accordion-title').click(function() {
      const $accordionItem = $(this).parent();
      const $toggleIcon = $(this).find('.toggle-icon');

      if ($accordionItem.hasClass('active')) {
        $accordionItem.removeClass('active').find('.accordion-content').slideUp('fast');
        $toggleIcon.text('+');
      } else {
        $('.accordion-item').removeClass('active').find('.accordion-content').slideUp('fast').prev('.accordion-title').find('.toggle-icon').text('+');
        $accordionItem.addClass('active').find('.accordion-content').slideDown('fast');
        $toggleIcon.text('-');
      }
    });
  });

document.addEventListener("DOMContentLoaded", function() {
  const elements = document.querySelectorAll('.product-collection__content.style_left .product-collection__title a');

  elements.forEach(function(element) {
    const text = element.textContent.trim();
    const maxLength = 60; // Maximum characters allowed

    if (text.length > maxLength) {
      const truncatedText = text.substring(0, maxLength).trim() + '...';
      element.textContent = truncatedText;
    }
  });
});





 
/*
// ============================ Gifts & Home Decor STARTS ==============================================
var element1 = document.querySelector("#shopify-section-template--22056247329090__6ed3d6a2-4475-4681-acb5-ed650d44fd40");

// Create the HTML content
var htmlContent1 = `
  <p style="text-align:center; margin-bottom:-20px; margin-top: 4.25rem ">
    <img src="https://cdn.shopify.com/s/files/1/0699/5676/3970/files/shiv-gift.png?v=1707478195" style="width:100px">
  </p>
`;
// Insert the HTML content at the start of the section
element1.insertAdjacentHTML('afterbegin', htmlContent1);
// =======================================================================================================


// ============================ Maha Shivaratri Special Collections STARTS ==============================================
var element2 = document.querySelector("#shopify-section-template--22056247329090__dynamic_featured_collection_y9nzYi");

// Create the HTML content
var htmlContent2 = `
  <p style="text-align:center; margin-bottom:-20px; margin-top: 4.25rem ">
    <img src="https://cdn.shopify.com/s/files/1/0699/5676/3970/files/Maha_Shivaratri_Special_Collections.png?v=1707483836" style="width:100px">
  </p>
`;
// Insert the HTML content at the start of the section
element2.insertAdjacentHTML('afterbegin', htmlContent2);
// ======================================================================================================
*/

/*
  // Function to add the 'active' class to buttons
  function addActiveClassToButtons() {
    const buttons = document.getElementsByClassName('site-header-menu-toggle');
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].classList.add('active');
    }
  }

  // Call the function initially to add the 'active' class
  addActiveClassToButtons();

  // Add an event listener to monitor changes to the DOM
  document.addEventListener('DOMContentLoaded', addActiveClassToButtons);

*/
